import React, {FC, useEffect, useRef, useState} from 'react';
import {IPortfolio,  IError,  IUpload} from "../types/types";
import {get, post, postv2, upload} from "../fetchers/fetchers";
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import SettingsIcon from '@material-ui/icons/Settings';
import DialogContentText from '@material-ui/core/DialogContentText';
import Portfolio from "./portfolio";
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    IconButton,
    TextField, TextFieldProps,
    Tooltip,
    withStyles
} from "@material-ui/core";
 
import {useHistory} from "react-router-dom";
import {useParams} from "react-router";
import Alert from "@material-ui/lab/Alert";
import SFIARPToolbar from './toolbar';
import { API_URL } from "../env";

interface IPortfoliosProps {
}

interface IRouteParams {
    id: string
}


const AddingButton = withStyles(theme => ({
    root: {
        margin:"auto",
        backgroundColor:"rgba(0,103,114,0.2)",
        color:"rgba(0,103,114,1)",
        '&:hover': {
            backgroundColor: "rgba(0,103,114,0.5)",
        },
    },
}))(IconButton);

const Portfolios: FC<IPortfoliosProps> = () => {

    const history = useHistory();

    const params = useParams<IRouteParams>()
    const [portfolios, setPortfolios] = useState<IPortfolio[]>([]);
    const [reload, setReload] = useState<boolean>(true);
    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const newProjectName = useRef<TextFieldProps>(null);

    // load access_level from local storage
    const access_level = Number(localStorage.getItem("access_level") || "");


    const getPortfolios = async () => {
        const d = await get<IPortfolio[]>( API_URL + "projects/");
        setPortfolios(d)
    }

    const addPortfolio = async (portfolio: IPortfolio) => {
        await post<IPortfolio>( API_URL + "projects/", portfolio);
        setReload(true)
    }

    const handleClose = () => {
        setOpenCreateDialog(false)
    }
    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const createPortfolio = () => {
        let projectName = newProjectName.current?.value as string
        addPortfolio({name: projectName, is_active:true}).then( () => setOpenCreateDialog(false) )

    }

    const handleSettings = () => {
        history.push("/admin")
    }

    useEffect(() => {

        if (reload) {
            getPortfolios().then(()=> setReload(false)).catch( (e)=>
            {
                history.push("/login");
            })
        }
    }, [reload])


    return (
            <>
            <SFIARPToolbar title={"Portfolios"}/>


            <Container>
            <Dialog open={openCreateDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Create Portfolio</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        To add a new portfolio to the SFAIRP Assessment please enter the name.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Portfolio name"
                        type="text"
                        fullWidth
                        inputRef={newProjectName}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={createPortfolio} color="primary">
                        Create
                    </Button>
                </DialogActions>
            </Dialog>

            <Grid container spacing={3} xl={12} direction="row" style={{padding:"20px", marginTop:"40px"}}>
                <Grid item xs={5} sm={3} md={2} lg={2}>
                    <div style={{position:"sticky", top:"68px"}}>
                        
                        { access_level > 2 && <Tooltip title="Create new project" placement={'bottom-end'}>
                            <AddingButton style={{backgroundColor:"rgb(239,88,43)", color: "#FFFFFF"}} onClick={prevState => handleOpen()} >
                                <AddIcon />
                            </AddingButton>
                        </Tooltip> }
                        <br/>
                        {access_level > 3 &&  <Tooltip title="Settings" placement={'bottom-end'}>
                            <AddingButton style={{backgroundColor:"rgb(239,88,43)", color: "#FFFFFF"}} onClick={prevState => handleSettings()} >
                                <SettingsIcon />
                            </AddingButton>
                        </Tooltip>
                        }
                        <br/>
                    </div>
                </Grid>
                <Grid item xs={7} sm={9} md={9} lg={10} container spacing={3}>

                    {portfolios.map(d => {
                        if (d.is_active) {
                            return (<Portfolio portfolio={d}/>)
                        }
                    })}
                </Grid>
            </Grid>
        </Container>
        </>
    );
};

export default Portfolios;

